// extracted by mini-css-extract-plugin
module.exports = {"root":"_3sCDP","SolidColorMenuButtonNSkin":"_3PptM","solidColorMenuButtonNSkin":"_3PptM","linkElement":"_1yi_g","wrapper":"_39-mO","label":"_1NCeO"};